<template>
  <div class="teleInfos">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="realPropertyAddress" placeholder="不动产地址" clearable></el-input>
        </el-form-item>
        <el-button type="primary" @click="selectList">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="addRent()">添加</el-button>
      <el-button type="primary" slot="header" @click="jump">{{$t('lang.btn_backpage')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="80px">
        </el-table-column>
        <el-table-column prop="realPropertyAddress" label="不动产地址" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailAddress" label="详细地址" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="rentStartDate" label="租赁期起" width="140"></el-table-column>
        <el-table-column prop="rentEndDate" label="租赁期止" width="140"></el-table-column>
        <el-table-column prop="crossCityFlag" label="跨地市" width="90">
          <template slot-scope="scope">
            {{ scope.row.crossCityFlag === '1' || scope.row.crossCityFlag === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="realPropertyCertificate" label="产权证号" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="areaUnit" label="面积单位" width="110">
          <template slot-scope="scope">
            {{ areaUnitLabel(scope.row.areaUnit) }}
          </template>
        </el-table-column>
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width4">
          <template slot-scope="scope">
            <el-button @click="changeRent(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="delRent(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="80px"
      width="700px" @closed="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws5"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item label="不动产地址" prop="realPropertyAddress">
          <el-input v-model="form.realPropertyAddress" placeholder="如：云南省昆明市西山区" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddress">
          <el-input v-model="form.detailAddress" placeholder="须含街/路/村/乡/镇/道等，总长不超过120" maxlength="120"></el-input>
        </el-form-item>
        <el-form-item label="租赁期起" prop="rentStartDate">
          <el-date-picker v-model="form.rentStartDate" type="date" value-format="yyyy-MM-dd"
            placeholder="选择租赁期起" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="租赁期止" prop="rentEndDate">
          <el-date-picker v-model="form.rentEndDate" type="date" value-format="yyyy-MM-dd"
            placeholder="选择租赁期止" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="跨地（市）" prop="crossCityFlag">
          <el-radio-group v-model="form.crossCityFlag">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="产权证号" prop="realPropertyCertificate">
          <el-input v-model="form.realPropertyCertificate" placeholder="产权证书/不动产权证号码" maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="面积单位" prop="areaUnit">
          <el-select v-model="form.areaUnit" placeholder="请选择面积单位" style="width:100%">
            <el-option v-for="item in areaUnitOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'rentInfo',
    data() {
      return {
        roomId: '',
        ownerId: '',
        realPropertyAddress: '',
        editId: '',
        titleShow: '',
        diaIsShow: false,
        pageNum: 1,
        pageSize: 10,
        pageCount: 0,
        tableData: [],
        areaUnitOptions: [
          { value: '1', label: '平方千米' },
          { value: '2', label: '平方米' },
          { value: '3', label: '公顷' },
          { value: '4', label: '亩' },
          { value: '5', label: 'h㎡' },
          { value: '6', label: 'km' },
          { value: '7', label: 'm' },
          { value: '8', label: '码' }
        ],
        form: {
          realPropertyAddress: '',
          detailAddress: '',
          rentStartDate: '',
          rentEndDate: '',
          crossCityFlag: '0',
          realPropertyCertificate: '',
          areaUnit: '2'
        },
        rules: {
          realPropertyAddress: [{ required: true, message: '请输入不动产地址', trigger: 'blur' }],
          detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
          rentStartDate: [{ required: true, message: '请选择租赁期起', trigger: 'change' }],
          rentEndDate: [{ required: true, message: '请选择租赁期止', trigger: 'change' }],
          crossCityFlag: [{ required: true, message: '请选择跨地（市）标志', trigger: 'change' }],
          realPropertyCertificate: [{ required: true, message: '请输入产权证号', trigger: 'blur' }],
          areaUnit: [{ required: true, message: '请选择面积单位', trigger: 'change' }]
        }
      }
    },
    created() {
      const row = this.$route.query.row || {}
      this.ownerId = row.id
      this.roomId = row.roomId
      this.selectList()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    methods: {
      areaUnitLabel(val) {
        const item = this.areaUnitOptions.find(o => o.value === String(val))
        return item ? item.label : val
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      tableRowClassName({ rowIndex }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      selectList() {
        let loading = this.$loading()
        const address = this.realPropertyAddress || ''
        this.$get(
          `/feeRealPropertyRentList?ownerId=${this.ownerId}&realPropertyAddress=${encodeURIComponent(address)}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list || []
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      resetForm() {
        this.form = {
          realPropertyAddress: '',
          detailAddress: '',
          rentStartDate: '',
          rentEndDate: '',
          crossCityFlag: '0',
          realPropertyCertificate: '',
          areaUnit: '2'
        }
      },
      addRent() {
        this.editId = ''
        this.titleShow = '添加租赁信息'
        this.resetForm()
        this.diaIsShow = true
      },
      changeRent(row) {
        this.editId = row.id
        this.titleShow = '修改租赁信息'
        this.form.realPropertyAddress = row.realPropertyAddress || ''
        this.form.detailAddress = row.detailAddress || ''
        this.form.rentStartDate = row.rentStartDate || ''
        this.form.rentEndDate = row.rentEndDate || ''
        this.form.crossCityFlag = row.crossCityFlag != null ? String(row.crossCityFlag) : '0'
        this.form.realPropertyCertificate = row.realPropertyCertificate || ''
        this.form.areaUnit = row.areaUnit != null ? String(row.areaUnit) : '2'
        this.diaIsShow = true
      },
      delRent(id) {
        let loading = this.$loading()
        this.$confirm(
          this.$i18n.t('lang.lab_isdelete'),
          this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }
        ).then(() => {
          this.$delete(`feeRealPropertyRentDel/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.selectList()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }).catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
      },
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (!valid) {
            return
          }
          if (this.form.rentStartDate && this.form.rentEndDate && this.form.rentStartDate > this.form.rentEndDate) {
            this.$message.warning('租赁期起不能晚于租赁期止')
            return
          }
          if (this.editId === '') {
            let params = {
              ownerId: this.ownerId,
              roomId: this.roomId,
              gardenId: this.gardenId,
              realPropertyAddress: this.form.realPropertyAddress,
              detailAddress: this.form.detailAddress,
              rentStartDate: this.form.rentStartDate,
              rentEndDate: this.form.rentEndDate,
              crossCityFlag: this.form.crossCityFlag,
              realPropertyCertificate: this.form.realPropertyCertificate,
              areaUnit: this.form.areaUnit
            }
            let loading = this.$loading()
            this.$post(`/feeRealPropertyRentAdd/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.selectList()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = {
              realPropertyAddress: this.form.realPropertyAddress,
              detailAddress: this.form.detailAddress,
              rentStartDate: this.form.rentStartDate,
              rentEndDate: this.form.rentEndDate,
              crossCityFlag: this.form.crossCityFlag,
              realPropertyCertificate: this.form.realPropertyCertificate,
              areaUnit: this.form.areaUnit
            }
            let loading = this.$loading()
            this.$patch(`/feeRealPropertyRentUpdate/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.selectList()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        })
      },
      clear() {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        this.resetForm()
      },
      jump() {
        this.$router.go(-1)
      },
      handleDialogClosed() {
        this.clear()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.selectList()
      },
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.selectList()
      }
    }
  }
</script>

<style lang="scss">
</style>
